import { memo } from "react";
import {VZHotTable} from "../../../components/vz-ui/vz-hot-table/VZHotTable";

const OperationalVZHotTable = memo(
    VZHotTable,
    (prev, next) => {
        return (
            prev.data === next.data &&
            prev.tableConfig === next.tableConfig &&
            prev.isDataLoading === next.isDataLoading
        );
    }
);

export default OperationalVZHotTable;
